module.exports = __webpack_public_path__ + "static/media/amd.f9d80b24.jpeg";